// **** Constants **** //

export const MAX_TASK_NAME_CHAR_LENGTH = 255;
export const MAX_TASK_DESCRIPTION_CHAR_LENGTH = 100;
const ADMIN_PATHS_ROOT = '/adminConfiguration';
const TASK_PATH_ROOT = `${ADMIN_PATHS_ROOT}/taskConfiguration`;
const FORM_PATH_ROOT = `${ADMIN_PATHS_ROOT}/restrictionFormConfiguration`;

export const AdminConfigPaths = {
  root: ADMIN_PATHS_ROOT,
  SITE: `${ADMIN_PATHS_ROOT}/siteConfiguration`,
  Task: {
    root: TASK_PATH_ROOT,
    TASKS: 'task',
    TASK_GROUPS: 'taskGroup',
    NON_PHYSICAL_TASKS: 'nonPhysicalTask',
  },
  Form: {
    root: FORM_PATH_ROOT,
    TABLE: `${FORM_PATH_ROOT}/forms`,
    EDIT: `${FORM_PATH_ROOT}/edit`,
  },
  MODIFICATION: `${ADMIN_PATHS_ROOT}/jobModificationConfiguration`,
} as const;
